/* eslint-disable linebreak-style */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/display-name */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useAmp } from 'next/amp';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import useDeviceScreen from 'root/hooks/useDeviceScreen';
import { intl } from 'components/LocaleProvider';
import Col from 'base-ui/dist/Col';
import Container from 'base-ui/dist/Container';
import PageWrapper from 'base-ui/dist/PageWrapper';
import Row from 'base-ui/dist/Row';
import Box from 'base-ui/dist/Box';
import Heading from 'base-ui/dist/Heading';
import Paragraph from 'base-ui/dist/Paragraph';
import Icon from 'base-ui/dist/Icon';
import Lists from 'base-ui/dist/Lists';
import Modal from 'base-ui/dist/Modal';
import NavLink from 'components/NavLink';
import RelatedDiseasesList from 'components/RelatedDiseasesList';
import RelatedDrugsSlider from 'components/RelatedDrugsSlider';
import { useAuth } from 'root/hooks/useAuth';

import isBrowser from 'utils/isBrowser';
import { Sentry } from 'root/utils/raven';
import apiClient from '../../lib/apiClient';

import messages from './messages';

const getConfig = require('next/config').default;

const RenderHtmlReactLoading = dynamic(
  () => import('utils/RenderHtmlReact/Loading'));
const BreadcrumbsLoading = dynamic(
  () => import('components/Breadcrumbs/Loading'));
const PostMetasLoading = dynamic(() => import('components/PostMetas/Loading'));
const AuthorSignedCardLoading = dynamic(
  () => import('components/AuthorSignedCard/Loading'));
const PostBibliographyLoading = dynamic(
  () => import('components/PostBibliography/Loading'));
const SponsorBoxLoading = dynamic(
  () => import('components/SponsorBox/Loading'));
const ShareButtonsLoading = dynamic(
  () => import('components/ShareButtons/Loading'));

const RenderHtmlReact = dynamic(
  () => import('utils/RenderHtmlReact'),
  {
    loading: () => (
      <RenderHtmlReactLoading
        mobile={{
          width: '480',
          height: '300',
        }}
        desktop={{
          width: '618',
          height: '500',
        }}
      />
    ),
  });
const Breadcrumbs = dynamic(
  () => import('components/Breadcrumbs'),
  {
    loading: () => (
      <BreadcrumbsLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const PostMetas = dynamic(
  () => import('components/PostMetas'),
  {
    loading: () => (
      <PostMetasLoading
        mobile={{
          width: '480',
          height: '20',
        }}
        desktop={{
          width: '618',
          height: '20',
        }}
      />
    ),
  });
const AuthorSignedCard = dynamic(
  () => import('components/AuthorSignedCard'),
  {
    loading: () => (
      <AuthorSignedCardLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });
const PostBibliography = dynamic(
  () => import('components/PostBibliography'),
  {
    loading: () => (
      <PostBibliographyLoading
        mobile={{
          width: '480',
          height: '64',
        }}
        desktop={{
          width: '618',
          height: '64',
        }}
      />
    ),
  });
const SponsorBox = dynamic(
  () => import('components/SponsorBox'),
  {
    loading: () => (
      <SponsorBoxLoading
        mobile={{
          width: '480',
          height: '84',
        }}
        desktop={{
          width: '618',
          height: '84',
        }}
      />
    ),
  });

const ShareButtons = dynamic(
  () => import('components/ShareButtons'),
  {
    loading: () => (
      <ShareButtonsLoading
        mobile={{
          width: '480',
          height: '40',
        }}
        desktop={{
          width: '110',
          height: '212',
        }}
      />
    ),
  });

const Image = dynamic(() => import('components/Image'));
const SEO = dynamic(() => import('components/SEO'));
const AdManager = dynamic(() => import('components/AdManager'));
const Sidebar = dynamic(() => import('components/Sidebar'));

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const getTargets = (post) => ({
  tags: post?.tags?.map((i) => i.name),
  postId: post.id,
  author: post?.author?.slug,
  authorId: post?.author?.id,
  section: 'single',
});

const Drug = ({ post, preview, fbp }) => {
  const { isPhone, isDesktop } = useDeviceScreen();
  const isAmp = useAmp();
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState({});
  const modalHeight = '30%';
  const modalWidth = !isDesktop ? '70%' : '50%';

  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  Sentry.addBreadcrumb({
    category: 'screens/Drug',
    message: `Render drug ${post?.link}`,
    level: Sentry.Severity.Debug,
  });

  useEffect(() => {
    if (fbp && isBrowser() && publicRuntimeConfig.dmp) {
      const tags = post?.tags?.map((v) => v.name);

      fbp.trackSingleCustom(publicRuntimeConfig.FACEBOOK_PIXEL_DMP,
        'ViewMSContent', {
          content_cat7: post.categories && post.categories.length
            ? post.categories[0].name
            : '',
          content_tags: tags && tags.length ? tags : [],
        });
    }
  }, [post, fbp]);

  const openModal = (data) => {
    setAlert(data);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <SEO resource={post} />
      <Container fluid wrap>
        <Row>
          <Col xs="12">
            <Breadcrumbs breadcrumbs={post.breadcrumbs || []} className={'margin-top-medium'} />
          </Col>
        </Row>
      </Container>
      <PageWrapper config={{ title: post.metas?.title, bodyClasses: 'single-landing' }}>
        <Box tag="main" id="site-main">
          <Container fluid wrap>
            <Row>
              <Col xs="12" md={isPhone || isAmp ? 12 : 8} sm="12">
                <Box tag="section" className={'section-text section-intro margin-bottom-big'}>
                  <Heading type={'h1'}>
                    <NavLink>
                      {post?.title}
                    </NavLink>
                  </Heading>

                  <PostMetas post={{ ...post, options: { ...post.options, author: 'off' } }} dateIcon="calendar" />

                  {isPhone && (
                    <>
                      <figure>
                        <Image src={post?.featured_media} alt={post.title} />
                      </figure>
                      <hr />
                    </>
                  )}

                  {post?.author && (
                    <AuthorSignedCard
                      author={post.author}
                      reviewed_by={post.reviewed_by}
                    />
                  )}

                  {post?.headline && (
                    <blockquote
                      dangerouslySetInnerHTML={{
                        __html: post.headline,
                      }}
                    />
                  )}

                  {!preview && (
                    <AdManager
                      type="box"
                      display={{
                        desktop: false,
                        tablet: false,
                        mobile: post?.options?.ads === 'on',
                      }}
                      targets={getTargets(post)}
                    />
                  )}

                  {!isPhone && (
                    <>
                      <figure>
                        <Image src={post?.featured_media} alt={post.title} />
                      </figure>
                      <hr />
                    </>
                  )}

                  {!preview && (
                    <AdManager
                      type="box"
                      display={{
                        desktop: post?.options?.ads === 'on',
                        tablet: post?.options?.ads === 'on',
                        mobile: false,
                      }}
                      targets={getTargets(post)}
                    />
                  )}

                  <Box tag="section" className="section-about-medicine margin-bottom-medium margin-top-big">
                    <Row>
                      {(post?.drug_info?.generic_name || post?.drug_info?.commercial_name || post?.drug_class) && (
                        <Col sm="12" md="6">
                          {post?.drug_info?.generic_name && (
                            <Paragraph>
                              <strong>
                                {intl.formatMessage(messages.genericName)}
                                {' '}
                              </strong>
                              <NavLink href={post?.drug_info?.generic_name_link}>{post?.drug_info?.generic_name}</NavLink>
                            </Paragraph>
                          )}

                          {post?.drug_info?.commercial_name && (
                            <Paragraph>
                              <strong>
                                {intl.formatMessage(messages.commercialName)}
                                {' '}
                              </strong>
                              {post?.drug_info?.commercial_name}
                            </Paragraph>
                          )}
                          {post?.drug_class && (
                            <Paragraph>
                              <Icon prefix="fas" name="tablets" />
                              <strong>
                                {intl.formatMessage(messages.typeDrug)}
                                {' '}
                              </strong>
                              <NavLink href={post?.drug_class[0]?.permalink}>{post?.drug_class[0]?.name}</NavLink>
                            </Paragraph>
                          )}

                        </Col>
                      )}

                      <Col sm="12" md="6">
                        {post?.route_administration && post?.route_administration.length > 0 && (
                          <>
                            <Paragraph>
                              <Icon prefix="fas" name="capsules" />
                              <strong>
                                {intl.formatMessage(messages.routeAdministration)}
                                {' '}
                              </strong>
                            </Paragraph>
                            <Lists>
                              {post?.route_administration?.map((item) => (
                                <li key={item.id}>
                                  <NavLink href={item.permalink}>{item.name}</NavLink>
                                </li>
                              ))}
                            </Lists>
                          </>
                        )}

                        {post?.drug_info?.warnings && post?.drug_info?.warnings.length > 0 && (
                          <>
                            <Paragraph>
                              <Icon prefix="fas" name="exclamation-circle" />
                              <strong>
                                {intl.formatMessage(messages.alertsComposition)}
                                {' '}
                              </strong>
                            </Paragraph>
                            <Lists>
                              {post?.drug_info?.warnings?.map((item) => (
                                <li key={item.id}>
                                  <a href onClick={() => openModal(item)}>{item.alert_name}</a>
                                </li>
                              ))}
                            </Lists>
                          </>
                        )}

                      </Col>
                    </Row>
                  </Box>

                  <div className="the-content">
                    <RenderHtmlReact
                      text={post.content}
                      post={post}
                      preview={preview}
                    />
                  </div>

                  <div id="single">
                    {post?.bibliography && <PostBibliography bibliography={post?.bibliography} />}
                  </div>
                  {(post?.options?.is_sponsored && post?.options?.sponsor)
                  && <SponsorBox sponsor={post?.options?.sponsor} />}

                </Box>

                <ShareButtons
                  post={post}
                  isAuthenticated={isAuthenticated}
                  bookmarks={bookmarks}
                  handleBookmarks={setBookmarks}
                />

                {post?.related_diseases && (
                  <RelatedDiseasesList
                    title={intl.formatMessage(messages.relatedDiseaseTitle)}
                    titleType="h3"
                    data={post?.related_diseases}
                  />
                )}
                {post?.related_drugs && (
                  <RelatedDrugsSlider
                    title={intl.formatMessage(messages.otherDrugs)}
                    titleType="h3"
                    className="margin-top-big margin-bottom-big"
                    data={post?.related_drugs}
                  />
                )}

                <Sidebar
                  sidebarSlug="single-lower-sidebar"
                  preview={preview}
                  ads={{
                    enabled: post?.options?.ads === 'on',
                    targets: getTargets(post),
                  }}
                />
              </Col>
              {!isPhone && !isAmp && (
                <aside id="sidebar" className="col-xs-12 col-md-4 hidden-md">

                  <Sidebar
                    sidebarSlug="single-sidebar"
                    preview={preview}
                    ads={{
                      enabled: post?.options?.ads === 'on',
                      targets: getTargets(post),
                    }}
                  />
                </aside>
              )}
            </Row>
          </Container>
        </Box>
      </PageWrapper>
      <Modal
        isOpen={open}
        appElement="#__next"
        closeModal={closeModal}
        closeIcon
        contentTitle={alert.alert_name}
        contentDescription={alert.alert_description}
        height={modalHeight}
        width={modalWidth}
      >
      </Modal>
    </React.Fragment>
  );
};

Drug.propTypes = {
  post: PropTypes.object,
  preview: PropTypes.bool,
  fbp: PropTypes.object,
};

export default Drug;
